import AppRouter from './routes/AppRouter'
import './style.css'

function App() {
  return (
    <div>
      <AppRouter/>
    </div>
  )
}

export default App
